// prompts.<area>.<key>: the suggested questions (services/platform-agent/platformAgentSuggestions.js), sent as typed.
// {{dish}} is a dish on the restaurant's menu, {{amount}} an amount in its currency (both from the picker).
export default {
  title: 'Hola {{first_name}}, ¿qué necesitas para {{restaurant}}?',
  title_no_name: 'Hola, ¿qué necesitas para {{restaurant}}?',
  text: 'Puedo responder preguntas sobre {{restaurant}} y hacer cambios por ti. Nada cambia hasta que lo apruebes.',
  suggestions: 'Sugerencias',
  // No restaurant selected (D18): Amigo asks which restaurant; the prompts let it ask for the restaurant's name.
  no_restaurant: {
    title: 'Hola {{first_name}}, ¿para qué restaurante es?',
    title_no_name: 'Hola, ¿para qué restaurante es?',
    text: 'Indica el restaurante en tu mensaje y trabajaré en él, sin abrirlo antes. Nada cambia hasta que lo apruebes.',
    prompts: {
      sunday_hours: 'Cambia el horario del domingo de un restaurante a 12:00–21:00',
      close_several: 'Cierra varios restaurantes el 24 de diciembre',
    },
  },
  prompts: {
    reports: {
      top_dishes: '¿Cuáles fueron los 10 platos más vendidos el mes pasado?',
      sales_vs_last_month: '¿Cómo fueron las ventas en comparación con el mes pasado?',
    },
    menu: {
      raise_dish_price: 'Subir el precio de {{dish}} en {{amount}}',
      dish_sold_out: 'Marcar {{dish}} como agotado',
      dishes_without_photo: '¿Qué platos no tienen foto?',
    },
    hours: {
      holiday_hours: 'Cambia nuestro horario de apertura del 24 de diciembre',
    },
    order_settings: {
      minimum_order: 'Subir el pedido mínimo a {{amount}}',
    },
    marketing: {
      promo_code: 'Crea un código promocional del 10 % para este fin de semana',
    },
    my_info: {
      phone_number: 'Actualiza nuestro número de teléfono',
    },
  },
};
